<template>
  <div>
    <AppLayout>
      <Loader :visible="loading"></Loader>
      <router-view />
    </AppLayout>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import router from '../router';
import Loader from '../components/Loader';

export default {
  name: 'App',
  components: {
    Loader
  },
  data() {
    return {
      loading: false
    }
  },
  created() {
    const landingPageName = 'Landing';

    if(this.$tenantName == 'public' && this.$route.name != landingPageName) {
      router.push({ name: landingPageName });
    } else {
      this.$root.$on('showLoader', this.showLoader);
      this.$root.$on('hideLoader', this.hideLoader);
      this.showEventTutorial();
    }
  },
  methods: {
    ...mapActions('Web', ['showEventTutorial']),
    showLoader() {
      this.loading = true
    },
    hideLoader() {
      this.loading = false
    }
  }
}
</script>

<style>
#app {
  /*
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  */
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
